export const WITHDRAW_INIT = `/api/v1/financial-coordinator/crypto/withdraw/init`;
